import React from "react";
import { Box } from "@mui/material";

const HERO_PHOTO = `${process.env.PUBLIC_URL || ""}/onthe%20farm.png`;

/** Light wash only — keeps photo legible; aligns with landing hero scrim family. */
const wash =
  "linear-gradient(180deg, rgba(250, 248, 244, 0.38) 0%, rgba(240, 245, 250, 0.32) 42%, rgba(230, 240, 248, 0.4) 100%), " +
  "linear-gradient(to bottom, rgba(26, 42, 58, 0.08) 0%, transparent 50%, rgba(26, 42, 58, 0.12) 100%)";

/**
 * Full-viewport calm backdrop (same farm photo family as the landing hero), very subtle wash.
 * Centers a single column; pass form content as children.
 */
export default function CalmAuthShell({ children, maxWidth = 440 }) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: { xs: 3, sm: 5 },
        position: "relative",
        overflow: "hidden",
        bgcolor: "#e8eef4",
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 0,
          backgroundImage: `${wash}, url(${JSON.stringify(HERO_PHOTO)})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <Box sx={{ position: "relative", zIndex: 1, width: "100%", maxWidth }}>{children}</Box>
    </Box>
  );
}

/** Frosted panel — reads over the photo without a harsh white slab. */
export const calmPanelSx = {
  bgcolor: "rgba(255, 255, 255, 0.58)",
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
  borderRadius: 2,
  border: "1px solid rgba(255, 255, 255, 0.42)",
  boxShadow:
    "0 1px 1px rgba(44, 64, 84, 0.06), 0 16px 48px rgba(26, 42, 58, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.5)",
};

export const calmInputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "rgba(255, 255, 255, 0.42)",
    transition: "background-color 0.15s ease, box-shadow 0.15s ease",
    "&:hover": { bgcolor: "rgba(255, 255, 255, 0.52)" },
    "&.Mui-focused": {
      bgcolor: "rgba(255, 255, 255, 0.78)",
      boxShadow: "0 0 0 1px rgba(74, 126, 176, 0.25)",
    },
  },
  "& .MuiInputLabel-root": { color: "rgba(44, 64, 84, 0.65)" },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(44, 64, 84, 0.14)",
  },
};

export const calmPrimaryButtonSx = {
  mt: 1,
  py: 1.25,
  borderRadius: 1.5,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.95rem",
  bgcolor: "#4a7eb0",
  boxShadow: "none",
  "&:hover": { bgcolor: "#3d6a9a", boxShadow: "none" },
  "&.Mui-disabled": { bgcolor: "rgba(74, 126, 176, 0.35)" },
};
